import { Pipe, PipeTransform } from '@angular/core';
import { BreadcrumbCategoryType } from '../../../_interfaces/header.interfaces';
import { FirebaseService } from '../../../_services/firebase.service';
import { ModuleEnum } from '../../../_utils/unums/module.enum';
import { BREADCRUMB_SETTINGS } from './breadcrumb.settings';
import { SimulationService } from 'src/app/_services/simulation.service';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'breadcrumbCategory'
})
export class BreadcrumbCategoryPipe implements PipeTransform {
  constructor(
    private simulationService: SimulationService,
    private translateService: TranslateService
  ) {
  }

  async transform(value: string, module: ModuleEnum, category?: BreadcrumbCategoryType): Promise<string> {
    if (category === 'simulation') {
      const simulation: string = await this.simulationService.getSimulationName(value);
      const simulationNameFragments = simulation[this.translateService.currentLang]?.split(':') || [];
      return (simulationNameFragments.length > 1? simulationNameFragments[1]: simulationNameFragments[0])?.trim();
    }
    if (category === 'module') {
      return BREADCRUMB_SETTINGS[category][value];
    }
    return value;
  }

}
